"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var AppLayout_1 = __importDefault(require("../Layouts/AppLayout"));
var Button_1 = __importDefault(require("../Jetstream/Button"));
var inertia_react_1 = require("@inertiajs/inertia-react");
var inertia_1 = require("@inertiajs/inertia");
var ej2_react_grids_1 = require("@syncfusion/ej2-react-grids");
require("@syncfusion/ej2/tailwind.css");
require("@syncfusion/ej2-base/styles/tailwind.css");
require("@syncfusion/ej2-react-grids/styles/tailwind.css");
var Label_1 = __importDefault(require("../Jetstream/Label"));
var ej2_react_calendars_1 = require("@syncfusion/ej2-react-calendars");
var ej2_react_querybuilder_1 = require("@syncfusion/ej2-react-querybuilder");
var ej2_react_dropdowns_1 = require("@syncfusion/ej2-react-dropdowns");
var ej2_react_inputs_1 = require("@syncfusion/ej2-react-inputs");
var ej2_react_buttons_1 = require("@syncfusion/ej2-react-buttons");
var ej2_base_1 = require("@syncfusion/ej2-base");
var moment_1 = __importDefault(require("moment"));
function Show() {
    var _a = (0, react_1.useState)(false), isOpen = _a[0], setIsOpen = _a[1];
    var _b = (0, react_1.useState)(false), editMode = _b[0], setEditMode = _b[1];
    var _c = (0, react_1.useState)({
        _method: '',
        id: '',
        title: '',
        rules: '{}',
        start_at: undefined,
        end_at: undefined,
        formula: '',
        multiplier: 1,
        no_further: false,
    }), selectedRow = _c[0], setSelectedRow = _c[1];
    // const [form, setForm] = useState<initialState>({
    //     _method: '',
    //     id: '',
    //     title: '',
    //     rules: '{}',
    //     start_at: '',
    //     end_at: '',
    //     formula: '',
    //     multiplier: 1,
    //     no_further: 0,
    // });
    var _d = (0, react_1.useState)({
        startMinDate: undefined,
        startMaxDate: undefined,
        endMinDate: undefined,
        endMaxDate: undefined,
        form: {
            _method: '',
            id: '',
            title: '',
            rules: '{}',
            start_at: undefined,
            end_at: undefined,
            formula: 'SetPoint',
            multiplier: 1,
            no_further: false,
        }
    }), state = _d[0], setState = _d[1];
    var props = (0, inertia_react_1.usePage)().props;
    var flash = props.flash, data = props.data;
    var gridExtras = {
        loadingIndicator: { indicatorType: 'Spinner' },
        emptyRecordTemplate: function () { return (react_1.default.createElement("span", { className: "text-gray-500" }, "No rewards found.")); },
    };
    var gridEditOptions = { allowEditing: true, allowAdding: true, allowDeleting: true };
    var gridToolbarOptions = [
        { text: 'Add', id: 'add' },
        { text: 'Edit', id: 'edit' },
        { text: 'Delete', id: 'delete' }
    ];
    var gridInstance;
    var gridClickHandler = function (args) {
        if (gridInstance) {
            switch (args.item.id) {
                case 'edit':
                    edit(selectedRow);
                    break;
                case 'add':
                    openModal();
                    break;
                case 'delete':
                    deleteRow(selectedRow);
                    break;
            }
        }
    };
    var gridRowSelected = function (args) {
        if (args.data) {
            setSelectedRow(args.data);
        }
    };
    var qbObj = new ej2_react_querybuilder_1.QueryBuilderComponent(props);
    var createdControl = function () {
        if (ej2_base_1.Browser.isDevice) {
            qbObj.summaryView = true;
        }
    };
    var columnData = [
        { field: 'ItemCode', label: 'Item Code', type: 'string' },
        {
            field: 'Total', label: 'Invoice Total', type: 'number', operators: [{ key: 'Equal', value: 'equal' },
                { key: 'Greater than', value: 'greaterthan' }, { key: 'Less than', value: 'lessthan' }]
        },
        { field: 'CustomerType', label: 'Customer Type', type: 'boolean', values: ['New', 'Existing'] },
        {
            field: 'Spend', label: 'Spend x', type: 'number', operators: [{ key: 'Equal', value: 'equal' },
                { key: 'Greater than', value: 'greaterthan' }, { key: 'Less than', value: 'lessthan' }]
        },
        { field: 'Period', label: 'x days', type: 'number' },
    ];
    var importRules = {};
    var openModal = function () {
        setIsOpen(true);
    };
    var closeModal = function () {
        setIsOpen(false);
        reset();
        setEditMode(false);
    };
    var reset = function () {
        setState({
            startMinDate: undefined,
            startMaxDate: undefined,
            endMinDate: undefined,
            endMaxDate: undefined,
            form: {
                _method: '',
                id: '',
                title: '',
                rules: '{}',
                start_at: undefined,
                end_at: undefined,
                formula: 'SetPoint',
                multiplier: 1,
                no_further: false,
            }
        });
    };
    var save = function () {
        setState(__assign(__assign({}, state), { form: __assign(__assign({}, state.form), { rules: JSON.stringify(qbObj.getValidRules(qbObj.rule)) }) }));
        inertia_1.Inertia.post('/rewards', __assign(__assign({}, state.form), { rules: JSON.stringify(qbObj.getValidRules(qbObj.rule)), start_at: (0, moment_1.default)(state.form.start_at).format('YYYY-MM-DD h:mm:ss'), end_at: (0, moment_1.default)(state.form.end_at).format('YYYY-MM-DD h:mm:ss'), _method: null, id: null }));
        reset();
        closeModal();
        setEditMode(false);
    };
    var edit = function (data) {
        setState(__assign(__assign({}, state), { form: selectedRow }));
        setEditMode(true);
        openModal();
    };
    var update = function () {
        var data = __assign(__assign({}, state.form), { _method: 'PUT', rules: JSON.stringify(qbObj.getValidRules(qbObj.rule)), start_at: (0, moment_1.default)(state.form.start_at).format('YYYY-MM-DD h:mm:ss'), end_at: (0, moment_1.default)(state.form.end_at).format('YYYY-MM-DD h:mm:ss') });
        inertia_1.Inertia.post('/rewards/' + state.form.id, data);
        reset();
        closeModal();
    };
    var deleteRow = function (data) {
        if (!confirm('Are you sure want to remove?'))
            return;
        data._method = 'DELETE';
        inertia_1.Inertia.post('/rewards/' + data.id, data);
        reset();
        closeModal();
    };
    var handleTitleChange = function (event) {
        setState(__assign(__assign({}, state), { form: __assign(__assign({}, state.form), { title: event.target.value }) }));
    };
    var handleFormulaChange = function (event) {
        setState(__assign(__assign({}, state), { form: __assign(__assign({}, state.form), { formula: event.target.value }) }));
    };
    var handleMultiplierChange = function (event) {
        setState(__assign(__assign({}, state), { form: __assign(__assign({}, state.form), { multiplier: event.target.value }) }));
    };
    var handleNoFurtherChange = function (event) {
        setState(__assign(__assign({}, state), { form: __assign(__assign({}, state.form), { no_further: event.target.value }) }));
    };
    var handleStartDatetimeChange = function (event) {
        setState(__assign(__assign({}, state), { form: __assign(__assign({}, state.form), { start_at: event.value }) }));
    };
    var handleEndDatetimeChange = function (event) {
        setState(__assign(__assign({}, state), { form: __assign(__assign({}, state.form), { end_at: event.value }) }));
    };
    return (react_1.default.createElement(AppLayout_1.default, { title: 'Rewards', renderHeader: function () { return (react_1.default.createElement("h2", { className: "font-semibold text-xl text-gray-800 leading-tight" }, "Manage Rewards")); } },
        react_1.default.createElement("div", { className: "py-12" },
            react_1.default.createElement("div", { className: "mx-auto sm:ps-6 lg:px-8" },
                react_1.default.createElement("div", { className: "bg-white overflow-hidden shadow-xl sm:rounded-lg px-4 py-4" },
                    flash.message && (react_1.default.createElement("div", { className: "bg-teal-100 border-t-4 border-teal-500 rounded-b text-teal-900 px-4 py-3 shadow-md my-3", role: "alert" },
                        react_1.default.createElement("div", { className: "flex" },
                            react_1.default.createElement("div", null,
                                react_1.default.createElement("p", { className: "text-sm" }, flash.message))))),
                    react_1.default.createElement(ej2_react_grids_1.GridComponent, __assign({ dataSource: data }, gridExtras, { allowPaging: true, editSettings: gridEditOptions, toolbar: gridToolbarOptions, toolbarClick: gridClickHandler, ref: function (g) { return gridInstance = g; }, rowSelected: gridRowSelected }),
                        react_1.default.createElement(ej2_react_grids_1.ColumnsDirective, null,
                            react_1.default.createElement(ej2_react_grids_1.ColumnDirective, { field: "title" }),
                            react_1.default.createElement(ej2_react_grids_1.ColumnDirective, { field: "start_at", headerText: "Start", format: "dd/MM/yyyy HH:mm", type: "datetime" }),
                            react_1.default.createElement(ej2_react_grids_1.ColumnDirective, { field: "end_at", headerText: "End", format: "dd/MM/yyyy HH:mm", type: "datetime" })),
                        react_1.default.createElement(ej2_react_grids_1.Inject, { services: [ej2_react_grids_1.Page, ej2_react_grids_1.Toolbar] }))))),
        isOpen && (react_1.default.createElement("div", { className: "fixed z-10 inset-0 overflow-y-auto ease-out duration-400" },
            react_1.default.createElement("div", { className: "flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0" },
                react_1.default.createElement("div", { className: "fixed inset-0 transition-opacity" },
                    react_1.default.createElement("div", { className: "absolute inset-0 bg-gray-500 opacity-75" }, "Title")),
                react_1.default.createElement("span", { className: "hidden sm:inline-block sm:align-middle sm:h-screen" }),
                react_1.default.createElement("div", { className: "inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-4xl sm:w-full", role: "dialog", "aria-modal": "true", "aria-labelledby": "modal-headline" },
                    react_1.default.createElement("form", null,
                        react_1.default.createElement("div", { className: "grid grid-cols-6 gap-6 py-2 px-4 " },
                            react_1.default.createElement("div", { className: "col-span-12" },
                                react_1.default.createElement(Label_1.default, null, "Title"),
                                react_1.default.createElement("input", { className: "e-input", value: state.form.title, onChange: handleTitleChange })),
                            react_1.default.createElement("div", { className: "col-span-12" },
                                react_1.default.createElement("div", { className: "grid grid-cols-6 gap-6" },
                                    react_1.default.createElement("div", { className: "col-span-3" },
                                        react_1.default.createElement(Label_1.default, null, "Start Date"),
                                        react_1.default.createElement(ej2_react_calendars_1.DateTimePickerComponent, { value: state.form.start_at, min: state.startMinDate, max: state.startMaxDate, change: handleStartDatetimeChange })),
                                    react_1.default.createElement("div", { className: "col-span-3" },
                                        react_1.default.createElement(Label_1.default, null, "End Date"),
                                        react_1.default.createElement(ej2_react_calendars_1.DateTimePickerComponent, { value: state.form.end_at, min: state.endMinDate, max: state.endMaxDate, change: handleEndDatetimeChange })))),
                            react_1.default.createElement("div", { className: "col-span-12" },
                                react_1.default.createElement(Label_1.default, null, "Rules"),
                                react_1.default.createElement(ej2_react_querybuilder_1.QueryBuilderComponent, { columns: columnData, rule: JSON.parse(state.form.rules), created: createdControl, ref: function (scope) {
                                        qbObj = scope;
                                    } })),
                            react_1.default.createElement("div", { className: "col-span-12" },
                                react_1.default.createElement("div", { className: "grid grid-cols-6 gap-6" },
                                    react_1.default.createElement("div", { className: "col-span-4" },
                                        react_1.default.createElement(Label_1.default, null, "Formula"),
                                        react_1.default.createElement(ej2_react_dropdowns_1.DropDownListComponent, { id: "formula", popupHeight: "220px", dataSource: [
                                                { value: "SetPoint", text: "Qantas Points" },
                                                // {id: "PointTotal", label: "Points per Invoice Total"},
                                                {
                                                    value: "PointLineItemTotal",
                                                    text: "Qantas Points per Line Item Total (e.g. x points per $1 on a line item)"
                                                }
                                            ], onChange: handleFormulaChange, value: state.form.formula })),
                                    react_1.default.createElement("div", { className: "col-span-2" },
                                        react_1.default.createElement(Label_1.default, null, "Multiplier"),
                                        react_1.default.createElement(ej2_react_inputs_1.NumericTextBoxComponent, { decimals: 2, format: "#,###.##", value: state.form.multiplier, onChange: handleMultiplierChange, min: 0.01 })))),
                            react_1.default.createElement("div", { className: "col-span-12 hidden" },
                                react_1.default.createElement("div", { className: "grid grid-cols-6 gap-6" },
                                    react_1.default.createElement("div", { className: "col-span-4" },
                                        "No further promo's apply. ",
                                        react_1.default.createElement(ej2_react_buttons_1.SwitchComponent, { id: "checked", checked: state.form.no_further, onChange: handleNoFurtherChange, onLabel: "Yes", offLabel: "No" })))),
                            react_1.default.createElement("div", { className: "col-span-12" },
                                react_1.default.createElement("div", { className: "bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse" },
                                    !editMode && (react_1.default.createElement("span", { className: "flex w-full rounded-md shadow-sm sm:ml-3 sm:w-auto" },
                                        react_1.default.createElement(Button_1.default, { onClick: save, type: "button", className: "inline-flex justify-center w-full rounded-md border border-transparent px-4 py-2 bg-green-600 text-base leading-6 font-medium text-white shadow-sm hover:bg-green-500 focus:outline-none focus:border-green-700 focus:shadow-outline-green transition ease-in-out duration-150 sm:text-sm sm:leading-5" }, "Save"))),
                                    editMode && (react_1.default.createElement("span", { className: "flex w-full rounded-md shadow-sm sm:ml-3 sm:w-auto" },
                                        react_1.default.createElement(Button_1.default, { onClick: update, type: "button", className: "inline-flex justify-center w-full rounded-md border border-transparent px-4 py-2 bg-green-600 text-base leading-6 font-medium text-white shadow-sm hover:bg-green-500 focus:outline-none focus:border-green-700 focus:shadow-outline-green transition ease-in-out duration-150 sm:text-sm sm:leading-5" }, "Update"))),
                                    react_1.default.createElement("span", { className: "flex w-full rounded-md shadow-sm sm:ml-3 sm:w-auto" },
                                        react_1.default.createElement(Button_1.default, { onClick: closeModal, type: "button", className: "inline-flex justify-center w-full rounded-md border border-gray-300 px-4 py-2 bg-white text-base leading-6 font-medium text-gray-700 shadow-sm hover:text-gray-500 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue transition ease-in-out duration-150 sm:text-sm sm:leading-5" }, "Cancel"))))))))))));
}
exports.default = Show;
